import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-grey-lighten-4 rounded p-3 mb-4" }
const _hoisted_2 = { class: "font-weight-medium" }
const _hoisted_3 = { class: "text-caption text-grey-darken-1 mt-1" }
const _hoisted_4 = { class: "text-caption text-grey-darken-1" }
const _hoisted_5 = { class: "text-caption text-grey-darken-1 mb-1" }
const _hoisted_6 = {
  key: 0,
  class: "ml-4",
  "data-cy": "granted-permissions"
}
const _hoisted_7 = {
  key: 0,
  class: "text-caption text-grey-darken-1"
}
const _hoisted_8 = {
  key: 1,
  class: "text-caption text-amber-darken-4"
}
const _hoisted_9 = {
  key: 2,
  class: "text-caption text-amber-darken-4"
}
const _hoisted_10 = {
  key: 1,
  class: "text-grey-darken-1 mb-0",
  "data-cy": "no-granted-permissions"
}
const _hoisted_11 = { class: "text-caption text-grey-darken-1 mt-4 mb-0" }

import { computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { getShortDateString } from '@/services/utils';
import type { AgentAccessConnection, AgentAccessPermission } from '../models/agentAccessTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectionPermissionsDialog',
  props: {
    modelValue: { type: Boolean },
    connection: {},
    permissions: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
});

// A scope with no catalogue entry is still listed, by its raw name. Dropping it would under-report what
// an agent can reach, which is the one direction this screen must never err in.
const describe = (scope: string): AgentAccessPermission =>
  props.permissions.find((p) => p.scope === scope)
  ?? ({ id: '', scope, label: scope, description: '', isWrite: false, requiresExplicitGrant: false } as AgentAccessPermission);

const granted = computed(() => (props.connection?.grantedScopes ?? []).map(describe));

// What the person approved stays on record, but the firm's cap decides what still works. Only the
// permissions that have to be named are checked: a wildcard grant narrows to its parts, so it never
// matches effectiveScopes token for token.
const isEffective = (scope: string) => (props.connection?.effectiveScopes ?? []).includes(scope);

const firstName = computed(() => props.connection?.userName?.split(' ')[0] ?? 'They');

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    "max-width": "520",
    "data-cy": "connection-permissions-dialog"
  }, {
    default: _withCtx(() => [
      (__props.connection)
        ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Connection permissions", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.connection.userName), 1),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.connection.userEmail) + " · " + _toDisplayString(__props.connection.agentName), 1),
                    _createElementVNode("div", _hoisted_4, " Connected " + _toDisplayString(_unref(getShortDateString)(__props.connection.consentedAtUtc)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(firstName.value) + " approved this agent for ", 1),
                  (granted.value.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(granted.value, (permission) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: permission.scope
                          }, [
                            _createTextVNode(_toDisplayString(permission.label) + " ", 1),
                            (permission.requiresExplicitGrant && !isEffective(permission.scope))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, " — not allowed by your firm "))
                              : (permission.requiresExplicitGrant)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " — can send email "))
                                : (permission.isWrite)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " — can change data "))
                                  : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_10, " No permissions were approved on this connection. ")),
                  _createElementVNode("p", _hoisted_11, " To end this access, revoke the connection. Revoking cannot be undone — " + _toDisplayString(firstName.value) + " would have to connect again and approve it afresh. ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "p-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(LlSecondaryButton, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("Close", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})